import { FormStatus } from "@/shared/modules/typescript-trustapi-client/models";
import { Options, Prop, Vue } from "vue-property-decorator";

@Options({})
export default class SessionExpired extends Vue {


  @Prop({ default: false })
  private modalOpened!: boolean;

  mounted() {
    if (!this.modalOpened) {
      document.body.classList.add('modal-open');
    }
  }

  beforeUnmount() {
    if (!this.modalOpened) {
      document.body.classList.remove('modal-open');
    }
  }

  private closeModal(): void {
    this.$emit('close');
  }

}

